import { IButtonProps } from "@/Interfaces/interface.buttons";
import React, {
  forwardRef,
  Ref,
} from "react";
import { Link } from "react-router-dom";
import twFocusClass from "utils/twFocusClass";

// ⚠️ The component is now wrapped in `forwardRef`
const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement, IButtonProps>(
  (props, ref) => {
    const {
      className = "",
      translate = "",
      sizeClass = "py-1.5 md:py-3 px-4 sm:py-2.5 sm:px-3",
      fontSize = "text-sm sm:text-base font-medium",
      disabled = false,
      href,
      children,
      targetBlank,
      type = "button",
      loading = false,
      onClick = () => { },
    } = props;

    const baseClass = `nc-Button relative h-auto inline-flex items-center justify-center rounded-full transition-colors ${fontSize} ${sizeClass} ${translate} ${className} ${twFocusClass(
      true
    )}`;

    const finalClass = `${baseClass} ${disabled || loading
      ? "opacity-50 pointer-events-none cursor-not-allowed"
      : ""
      }`;

    const _renderLoading = () => (
      <svg
        className="animate-spin -ml-1 mr-3 h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="3"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    );

    if (href && typeof href === "string") {
      return (
        <Link
          to={href}
          ref={ref as Ref<HTMLAnchorElement>}
          className={finalClass}
          target={targetBlank ? "_blank" : undefined}
          aria-disabled={disabled || loading}
        >
          {loading && _renderLoading()}
          {children}
        </Link>
      );
    }

    return (
      <button
        ref={ref as Ref<HTMLButtonElement>}
        disabled={disabled || loading}
        className={finalClass}
        onClick={onClick}
        type={type}
      >
        {loading && _renderLoading()}
        {children || `This is Button`}
      </button>
    );
  }
);

Button.displayName = "Button";
export default Button;
